import Parse from "parse";
import ParseConfig from "@/api/parse.config";
import codeGenerator from "@/services/general/codeGenerator.js";
import { updateCredits } from "@/services/utilisateurs/globalSettingsUser.js";

const UserService = {
  createUser(userData, selectedState, removedFoldersId, dureeAcces) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("RemoveFolders :", removedFoldersId);
        var group = Parse.User.current().get("group");
        var userTherapeute = Parse.User.current();
        var username = userData.lastname + userData.firstname;
        var mail = userData.mail;
        var dateNow = new Date();
        var user = new Parse.User();
        var relatedFoldersArray = [];

        user.set("firstname", userData.firstname);
        user.set("lastname", userData.lastname);

        const userType =
          selectedState === "licence" ? "patient_distance" : "patient_cabinet";
        user.set("user_type", userType);

        // Questionnaire début
        let questionnaireRelation = user.relation("QuestionnaireBeginIdList");
        if (userData.flashQuestionnaire || userData.flashQuestionnaire2) {
          for (let idQuestionnaire of userData.BeginQuestionnaireIds) {
            const QuestionnaireQuery = new Parse.Query("questionnaire");
            QuestionnaireQuery.equalTo("objectId", idQuestionnaire);
            const questionnaire = await QuestionnaireQuery.first();
            if (questionnaire) {
              user.set("QuestionnaireBegin", true);
              user.set("QuestionnaireBeginId", questionnaire);
              questionnaireRelation.add(questionnaire);
            }
          }
        }

        // Email ou pseudo
        let finalUsername;
        if (mail) {
          user.set("email", userData.mail);
          user.set("username", userData.mail);
        } else {
          finalUsername = await generateUniqueUsername(
            userData.lastname + userData.firstname
          );
          user.set("username", finalUsername);
        }

        const passwordGenerate = codeGenerator("xxxxxxxx");
        user.set("password", passwordGenerate);
        user.set("proposition_affiliation", false);
        user.set("withdrawal_credit_date", dateNow);
        user.set("cgu", false);
        user.set("therapeute", false);
        user.set("group", group);
        user.set("type_pratique", selectedState);

        if (selectedState === "licence") {
          user.set("date_debut_licence", dateNow);
          dureeAcces = parseInt(dureeAcces);
          user.set("duree_acces", dureeAcces);
          user.set("acces_donnees_therapeute", false);
          user.set("newsletters", false);
          user.set("acces_donnees_symbiocenter", true);
          var dateFinLicence = new Date();
          var dureeEnJours = dureeAcces * 30;
          dateFinLicence.setDate(dateFinLicence.getDate() + dureeEnJours);
          user.set("fin_acces_plateforme", dateFinLicence);

          await Parse.Cloud.run("pratiqueSousLicence", {
            destinataire: userData.mail,
            utilisateur: userData.firstname + " " + userData.lastname,
            password: passwordGenerate,
            therapeute:
              userTherapeute.get("firstname") +
              " " +
              userTherapeute.get("lastname"),
            dureeAcces: dureeAcces,
          });
        }

        // Folders / liens
        const linkRelation = user.relation("link");
        const queryAvailableFolders = new Parse.Query("AvailableFolders");
        const results = await queryAvailableFolders.find();

        if (results.length > 0) {
          for (const folder of results) {
            const foldersQuery = folder.relation("folders").query();
            const relatedFolders = await foldersQuery.find();
            relatedFoldersArray.push(...relatedFolders);
          }

          relatedFoldersArray = relatedFoldersArray.filter((folder) =>
            removedFoldersId.includes(folder.id)
          );

          for (const folder of relatedFoldersArray) {
            const linkQuery = new Parse.Query("link");
            linkQuery.equalTo("folder", folder);
            const link = await linkQuery.first();
            if (link) linkRelation.add(link);
          }

          const savedUser = await user.save();
          resolve(savedUser);
        } else {
          reject("Aucun dossier disponible");
        }
      } catch (error) {
        console.error("Erreur lors de la création de l'utilisateur", error);
        reject(error);
      }
    });
  },

  createTherapeute(user, progressCallback, isStagiaire) {
    ParseConfig();
    return new Promise(async (resolve, reject) => {
      try {
        const relatedFoldersArray = [];
        const NewUser = new Parse.User();

        NewUser.set("firstname", user.prenom);
        NewUser.set("lastname", user.nom);
        NewUser.set("compte_actif", true);
        NewUser.set("cgu", true);

        // 👉 Généralisation : valeurs dynamiques
        NewUser.set("therapeute", true); // booléen
        NewUser.set("user_type", user.user_type || null);

        NewUser.set("telephone_pro", user.telephone_pro || "");
        NewUser.set("username", user.mail);
        NewUser.set("profession", user.profession || "");
        NewUser.set("email", user.mail);
        NewUser.set("new_version_enabled", true);

        progressCallback(10);

        if (user.password === user.confirmPassword) {
          NewUser.set("password", user.password);
        }

        progressCallback(20);

        const linkRelation = NewUser.relation("link");
        const queryAvailableFolders = new Parse.Query("AvailableFolders");

        progressCallback(30);

        const results = await queryAvailableFolders.find();

        if (results.length > 0) {
          progressCallback(40);

          for (const folder of results) {
            const foldersQuery = folder.relation("folders").query();
            const relatedFolders = await foldersQuery.find();
            relatedFoldersArray.push(...relatedFolders);
          }

          progressCallback(50);

          for (const folder of relatedFoldersArray) {
            const linkQuery = new Parse.Query("link");
            linkQuery.equalTo("folder", folder);
            const link = await linkQuery.first();
            if (link) linkRelation.add(link);
          }

          progressCallback(60);
        }

        const UserGroup = new Parse.Object("user_group");

        const domaineQuery = new Parse.Query("domaine");
        domaineQuery.equalTo("nom", "Santé");
        const domaineResult = await domaineQuery.first();

        progressCallback(70);

        UserGroup.set("domaine", domaineResult);
        UserGroup.set("compte_valide", false);
        UserGroup.set("name", `${user.prenom}${user.nom}`);
        UserGroup.set("essai_gratuit", true);

        const passwordGenerateTherapeute = codeGenerator("xxxxxxxx");
        UserGroup.set("password_cabinet", passwordGenerateTherapeute);

        const AppParam = Parse.Object.extend("app_param");
        const paramQuery = new Parse.Query(AppParam);
        const appParams = await paramQuery.first();

        const dateEnd = new Date();
        if (!isStagiaire) {
          const nbJoursEssais = appParams.get("nbJoursEssais");
          dateEnd.setDate(dateEnd.getDate() + nbJoursEssais);
        } else {
          const nbJoursEssaisStagiaire = appParams.get(
            "nbJoursEssaisStagiaire"
          );
          dateEnd.setDate(dateEnd.getDate() + nbJoursEssaisStagiaire);
        }

        UserGroup.set("subscription_end_date", dateEnd);
        UserGroup.set("credits", 60);
        UserGroup.set("type_abonnement", "pulse");

        progressCallback(90);

        const userGroupSave = await UserGroup.save();
        NewUser.set("group", userGroupSave);

        let progress = 90;
        const intervalId = setInterval(() => {
          if (progress < 100) {
            progress++;
            progressCallback(progress);
            if (progress >= 99) clearInterval(intervalId);
          }
        }, 1000);

        NewUser.save()
          .then((savedUser) => {
            progressCallback(100);
            resolve(savedUser);
          })
          .catch((error) => {
            console.error("Erreur lors de la création de l'utilisateur", error);
            reject(error);
          });
      } catch (error) {
        console.error("Erreur générale", error);
        reject(error);
      }
    });
  },
};

async function generateUniqueUsername(baseUsername) {
  let query = new Parse.Query(Parse.User);
  let index = 1;
  let finalUsername = baseUsername;

  while (true) {
    query.equalTo("username", finalUsername);
    const existingUser = await query.first();
    if (!existingUser) {
      return finalUsername;
    }
    finalUsername = baseUsername + index;
    index++;
  }
}

export default UserService;
